import { render, staticRenderFns } from "./HomeView2.vue?vue&type=template&id=75040a96&"
import script from "./HomeView2.vue?vue&type=script&lang=js&"
export * from "./HomeView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports